import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

const EditClassModal = ({ show, handleClose, classData }) => {
  const [updatedClass, setUpdatedClass] = useState({
    class_name: '',
    course_id: '',
  })
  const [courses, setCourses] = useState([])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  useEffect(() => {
    if (classData) {
      setUpdatedClass({
        class_name: classData.class_name || '',
        course_id: classData.course_id || '',
        start_date: classData.start_date
          ? classData.start_date.split('T')[0]
          : '',
        end_date: classData.end_date ? classData.end_date.split('T')[0] : '',
      })
    }
  }, [classData])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedClass((prev) => ({ ...prev, [name]: value }))
  }

  const handleSaveChanges = async () => {
    try {
      const response = await ApiEndpoints.editClass(classData.id, updatedClass)
      toast.success(response.data.result)
      handleClose()
    } catch (error) {
      toast.error(error.response?.data?.result)
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title>Edit Class</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Class Name</Form.Label>
            <Form.Control
              type="text"
              name="class_name"
              value={updatedClass.class_name}
              onChange={handleInputChange}
              placeholder="Enter Class Name"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Course</Form.Label>
            <Form.Select
              name="course_id"
              value={updatedClass.course_id}
              onChange={handleInputChange}
            >
              <option value="">Select Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              name="start_date"
              value={updatedClass.start_date}
              onChange={handleInputChange}
            />
          </Form.Group>{' '}
          <Form.Group className="mb-3">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              name="end_date"
              value={updatedClass.end_date}
              onChange={handleInputChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditClassModal
